import React from "react";
import {
  Box,
  Typography,
  IconButton,
} from "@mui/material";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import { useModerationStore } from "../../store/moderationStore";
import { ConfigurationTabs } from "./ConfigurationTabs";

interface ConfigurationPageProps {
  onBack?: () => void;
}

export const ConfigurationPage: React.FC<ConfigurationPageProps> = ({
  onBack,
}) => {
  const { loadConfig, loadBlocklist, loadAllowlist } = useModerationStore();

  const defaultOnBack = () => {
    if (typeof window !== "undefined" && window.localStorage) {
      localStorage.setItem("activeScreenId", "moderation");
      window.location.reload();
    }
  };

  const handleRefresh = () => {
    loadConfig();
    loadBlocklist();
    loadAllowlist();
  };

  return (
    <Box sx={{ p: 3 }}>
      <Typography variant="h4" gutterBottom>
        Moderation Configuration
      </Typography>
      <Typography variant="body2" color="text.secondary" gutterBottom>
        Configure moderation thresholds, blocklist, and allowlist
      </Typography>
      <Box sx={{ mt: 3 }}>
        <Box sx={{ display: "flex", gap: 2, mb: 2, alignItems: "center" }}>
          <IconButton
            onClick={onBack || defaultOnBack}
            color="primary"
            sx={{ border: "1px solid rgba(0, 0, 0, 0.12)" }}
            title="Back to Moderation"
          >
            <ArrowBackIcon />
          </IconButton>
        </Box>

        <ConfigurationTabs onRefresh={handleRefresh} />
      </Box>
    </Box>
  );
};
